import { ModalProps } from 'antd'

import { Modal } from '@/components/shared-components/BUI/Modal'

import { buildPassTheme } from 'src/styles/theme'

const MODAL_Z_INDEX = 200000

type Props = ModalProps & {
  isModalOpen: boolean
  closeModal: () => void
  title: string
  footer?: React.ReactNode[]
}

export const TemplateModal: React.FC<Props> = ({
  isModalOpen,
  closeModal,
  title,
  footer,
  children,
  ...antModalProps
}) => {
  return (
    <Modal
      {...antModalProps}
      open={isModalOpen}
      title={title}
      onCancel={closeModal}
      zIndex={MODAL_Z_INDEX}
      bodyStyle={{ background: buildPassTheme.colour.neutral.surface }}
      footer={footer}
      destroyOnClose
      centered
    >
      {children}
    </Modal>
  )
}
